

exports.__esModule = true;
exports.$WalletModel = undefined;

var _squid = require('squid');

var _instrument = require('./instrument');

// ID https://engineering.paypalcorp.com/confluence/display/PayPalMediaService/Image+Request+Metadata+Data
var imageSizeId = '0';

var normalize = function normalize(instId) {
    return instId && instId.replace(/-/g, '');
};

var imageTypes = ['png', 'jpg', 'gif', 'bmp'];
var imageType = function imageType(mimeType) {
    return _squid.$util.find(imageTypes, function (t) {
        return mimeType.indexOf(t) !== -1;
    }) || 'png';
};

// Network types to check for linked cards
var NETWORK_TYPES = {
    CHASE: 'CHASENET'
};

function capFirst(string) {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

function getLinkedCapability(cardData) {
    return cardData.fs.capabilities.find(function (cap) {
        return cap.name === 'TOKEN';
    });
}

var $WalletModel = exports.$WalletModel = _squid.$Model.extend('$WalletModel', {
    invalidateOnLogout: true,
    api: new _squid.$Api({
        uri: '/api/fi/wallet/wallet'
    }),

    getId: function getId(fs) {
        return normalize(fs.instrument_id || fs.id);
    },

    getCardMask: function getCardMask(fs) {
        var rep = this.getWalletRepresentation(fs);

        if (!rep) {
            return { mask: true };
        }

        var selector = rep.type === 'card' ? 'product_class' : 'type';
        var renderedType = void 0;

        if (rep.fs[selector] === 'UNKNOWN' || !rep.fs[selector]) {
            renderedType = '';
        } else {
            renderedType = capFirst(rep.fs[selector]) + ' ';
        }

        return {
            before: renderedType,
            mask: true,
            after: rep.fs.last_nchars || rep.fs.last_nchars_card_number || ''
        };
    },

    /**
     * Returns the wallet API data for a FI given a funding source from the checkoutSession model
     * @returns {Instrument|BankInstrument|null}
     */
    getWalletRepresentation: function getWalletRepresentation(fs) {
        if (!fs) {
            return null;
        }

        if (fs.type === 'BALANCE') {
            var currency = fs.amount && fs.amount.currency_code;

            if (currency) {
                var bal = this.balance_accounts.find(function (b) {
                    return b.currency_code === currency;
                });

                if (bal) {
                    return new _instrument.Instrument({ type: 'balance', fs: bal });
                }
            }
            return null;
        }

        return this.getById(this.getId(fs));
    },


    /**
     * Returns the wallet API data for a FI based on the id provided
     * @returns {Instrument|BankInstrument|null} - the model of the FI, if found
     */
    getById: function getById(id) {
        if (!id) {
            return null;
        }

        return this.getCardById(id) || this.getBankById(id) || this.getCreditById(id) || null;
    },


    /**
     * Return the wallet API data for a FI of a card id provided
     * @returns {Instrument}
     */
    getCardById: function getCardById(id) {
        var card = _squid.$util.find(this.card_accounts, function (c) {
            return normalize(c.id) === id;
        });

        return card && new _instrument.Instrument({
            type: 'card',
            fs: card
        });
    },


    /**
     * Return the wallet API data for a FI of a card id provided
     * @returns {Instrument}
     */
    getCreditById: function getCreditById(id) {
        var creditCards = _squid.$util.find(this.credit_accounts, function (c) {
            return normalize(c.id) === id;
        });

        return creditCards && new _instrument.Instrument({
            type: 'credit',
            fs: creditCards
        });
    },


    /**
     * Return the wallet API data for a FI of a bank id provided
     * @returns {BankInstrument}
     */
    getBankById: function getBankById(id) {
        var bank = _squid.$util.find(this.bank_accounts, function (b) {
            return normalize(b.id) === id;
        });

        return bank && new _instrument.BankInstrument({
            type: 'bank',
            fs: bank
        });
    },


    getCustomName: function getCustomName(fs) {
        try {
            var rep = this.getWalletRepresentation(fs);

            if (!rep || !rep.type) {
                return '';
            }

            var type = rep.type.toLowerCase();

            if (type === 'credit' && rep.fs && rep.fs.credit_product_descriptor) {
                return rep.fs.credit_product_descriptor;
            }

            if (type === 'card' && rep.fs && rep.fs.issuer && rep.fs.issuer.issuer_product_description) {
                return rep.fs.issuer.issuer_product_description;
            }

            return '';
        } catch (e) {
            console.error('getCustomNameError', e);
            return '';
        }
    },

    getCardArt: function getCardArt(fs) {
        try {
            if (!fs || !fs.type) {
                console.error('Invalid input: fs is missing or does not have a type.', fs);
                return null;
            }

            var type = fs.type.toLowerCase();

            var cardId = this.getId(fs);

            var card = void 0,
                propertyPath = void 0;

            if (type === 'card') {
                card = this.getCardById(cardId);
                console.debug('Retrieved Card:', card);

                if (card && card.fs && card.fs.card_art_details && card.fs.card_art_details.card_art) {
                    propertyPath = card.fs.card_art_details.card_art.primary_content;
                }
            } else if (type === 'credit' || type === 'txn_card_bml') {
                card = this.getCreditById(cardId);
                console.debug('Retrieved Credit:', card);

                if (card && card.fs && card.fs.art_details) {
                    propertyPath = card.fs.art_details.primary_content;
                }
            }

            if (!propertyPath) {
                console.error('propertyPath is missing:', propertyPath);
                return null;
            }

            var base = propertyPath.base_cdn_link_path || propertyPath.base_cdnlink_path;

            console.debug('Base CDN Link Path:', base);

            if (!base) {
                console.error('Base CDN link path is missing.');
                return null;
            }

            return base + imageSizeId + '.' + imageType(propertyPath.original_mime_type);
        } catch (e) {
            console.error('getCardArtError', e);
            return null;
        }
    },

    /**
     * retrieve list of total balances (each currency is a separate balance account)
     * Notes:
     * 1. Skip balances with '0' amount
     * 2. Since wallet returns amount in "cents" - convert it to "dollars".
     *    For us it's safe to divide by 100 as PayPal doesn't support currencies with more than 2 decimal points.
     *    For those currencies with no decimal points - wallet adds two zeros, e.g
     *        in case of JPY - 1 JPY will be sent as 100 to the response
     */
    getAmountsOfBalances: function getAmountsOfBalances() {
        var balances = [];

        this.get('balance_accounts', []).forEach(function (balanceAccount) {
            var _balanceAccount$sub_b = balanceAccount.sub_balances.find(function (subBalance) {
                return subBalance.type === 'TOTAL_BALANCE';
            }),
                amount = _balanceAccount$sub_b.amount;

            if (amount.value !== '0') {
                balances.push({
                    value: Number(amount.value) / 100,
                    currency: amount.currency
                });
            }
        });

        return balances;
    },

    isLinkedCard: function isLinkedCard(fi) {
        var id = this.getId(fi);
        var card = this.getCardById(id);
        var hasLinkedCapability = card && !!getLinkedCapability(card);

        return hasLinkedCapability;
    },


    /**
     * Check if the given CI passed is a ChasePay linked card, which means it was added by linking to their Chase account
     */
    isChaseLinkedCard: function isChaseLinkedCard(fi) {
        var id = this.getId(fi);
        var card = this.getCardById(id);
        var linkedCapability = card && getLinkedCapability(card);

        if (!linkedCapability) {
            return false;
        }

        return linkedCapability.network_contingencies.some(function (networkInfo) {
            return networkInfo.network === NETWORK_TYPES.CHASE;
        });
    }
});

angular.value("$WalletModel", $WalletModel);
_squid.$Model;

_squid.$Api;

_squid.$util;

_instrument.Instrument;

_instrument.BankInstrument;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-models/src/wallet/index.js
// module id = ../node_modules/xo-models/src/wallet/index.js
// module chunks = 0